import classNames from 'classnames';
import { useFormik } from 'formik';
import { FC, useCallback, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useForgotPassword } from '../../../apis/hooks/auth';
import USERS from '../../../common/data/userDummyData';
import Button from '../../../components/bootstrap/Button';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import useDarkMode from '../../../hooks/useDarkMode';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';

interface ILoginHeaderProps {
	isNewUser?: boolean;
}
const LoginHeader: FC<ILoginHeaderProps> = ({ isNewUser }) => {
	return (
		<>
			<div className='text-center h2 fw-bold mt-5'>Welcome,</div>
			<div className='text-center h5 text-muted mb-5'>
				Please Enter your Login Email Below.
			</div>
		</>
	);
};

interface ILoginProps {
	isSignUp?: boolean;
}
const ForgotPassword: FC<ILoginProps> = ({ isSignUp }) => {
	const { darkModeStatus } = useDarkMode();

	const [singUpStatus, setSingUpStatus] = useState<boolean>(!!isSignUp);

	const navigate = useNavigate();
	const handleOnClick = useCallback(() => navigate('/admin/auth-pages/login'), [navigate]);

	const { mutate: mutateLogin, isError, error } = useForgotPassword();

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			loginUsername: USERS.JOHN.username,
			loginPassword: USERS.JOHN.password,
		},
		validate: (values) => {
			const errors: { loginUsername?: string; loginPassword?: string } = {};

			if (!values.loginUsername) {
				errors.loginUsername = 'Required';
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: (values) => {
			mutateLogin(
				{
					username: values.loginUsername,
				},
				{
					onSuccess: (res) => {
						handleOnClick();
						toast.success('Please check your email account.');
					},
					onError: (err) => {
						formik.setFieldError(
							'loginPassword',
							'Username and password do not match.',
						);
					},
				},
			);
		},
	});

	return (
		<PageWrapper isProtected={false} title={'Forgot Password'} className={'bg-light'}>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark' data-tour='login-page'>
							<CardBody>
								<div className='text-center my-5'>
									<Link
										to='/'
										className={classNames(
											'text-decoration-none  fw-bold display-6',
										)}
										aria-label='Facit'>
										{/* <Logo width={200} /> */}
										<h1>Neel's Sanjayraj</h1>
									</Link>
								</div>
								<div
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-dark': darkModeStatus,
									})}>
									<div className='row row-cols-1 g-3 pb-3 px-3 mt-0'>
										<div className='col'>
											<Button
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={singUpStatus}
												className='rounded-1 w-100'
												size='lg'
												onClick={() => {
													setSingUpStatus(!singUpStatus);
												}}>
												Forgot Password
											</Button>
										</div>
									</div>
								</div>

								<LoginHeader isNewUser={singUpStatus} />

								<form className='row g-4'>
									<>
										<div className='col-12'>
											<FormGroup
												id='loginUsername'
												isFloating
												label='Your email'>
												<Input
													autoComplete='username'
													value={formik.values.loginUsername}
													isTouched={formik.touched.loginUsername}
													invalidFeedback={formik.errors.loginUsername}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onFocus={() => {
														formik.setErrors({});
													}}
												/>
											</FormGroup>
										</div>
										<div className='col-12'>
											<Button
												color='warning'
												className='w-100 py-3'
												onClick={formik.handleSubmit}>
												Forgot Password
											</Button>
										</div>
									</>
								</form>
							</CardBody>
						</Card>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default ForgotPassword;
